import ApiCall from "../constants/Api";
import SiteConfig from "../constants/SiteConfig";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";

export const useDeleteFunctions = () => {
  //DeleteTrack function
  const deleteTrack = async (request, data) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.DELETE_TRACK,
        {
          ...request,
        },
        data.LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //DeleteTrackCategory function
  const deleteTrackCategory = async (request, data) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.DELETE_TRACK_CATEGORY,
        {
          ...request,
        },
        data.LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //DeleteTrackAltCategory function
  const deleteTrackAltCategory = async (request, data) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.DELETE_TRACK_ALT_CATEGORY,
        {
          ...request,
        },
        data.LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //DeleteLimitSet function
  const deleteLimitSet = async (request, data) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_MGMT_SVC,
        ApiCall.DELETE_LIMIT_SET,
        {
          ...request,
        },
        data.LogonSessionID
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  return {
    deleteTrack,
    deleteTrackCategory,
    deleteTrackAltCategory,
    deleteLimitSet,
  };
};
